import React, { useEffect, useState } from 'react'
import Modal from '../../Modal/Modal'
import api from '../../../api/api';
import { Avatar, Card, Link, Stack, Typography } from '@mui/material';
import ScrollEffect from '../../../effects/ScrollEffect';
import hasNoValue from '../../../utils/helpers/hasNoValue';

export default function ExcelFileUploadHistoryModal() {
  const [fileHistory, setFileHistory] = useState([]);

  useEffect(() => {
    (async () => {
      const resp = await api.getExcelFileHistory();
      console.log('ExcelFileUploadHistoryModal resp', resp);
      setFileHistory(resp);
    })();
  }, []);

  /*
{
    "userEmail": "Tristin.Cunningham@heycarter.co.za",
    "fileName": "Example-DealPortal-Excel-Upload.xlsx",
    "storageLink": "https://app.heycarter.com/CRMAPI/GetCallRecording?Key=DealPortal/FileHistory/Example-DealPortal-Excel-Upload.xlsx_0cec9f1d-5565-4326-b6d3-74cbb449ab88",
    "insertDateTime": "2024-10-23T10:09:33.58"
}
  */

  return (
    <Modal title="Excel file upload history">
      <ScrollEffect height="80vh">
        <Stack gap={"8px"}>
        {hasNoValue(fileHistory) && (
          <Typography>No history to display</Typography>
        )}
        {fileHistory?.map(item => (
          <Card variant='outlined' style={{ padding: "12px 8px", backgroundColor: "#f6f6f6" }}>
            <Stack gap={"8px"}>
              <Stack direction={"row"} gap={"8px"}>
                <Avatar sx={{ bgcolor: "#1D6F42" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256">
                    <path fill="currentColor" d="M200 24H72a16 16 0 0 0-16 16v24H40a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h16v24a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V40a16 16 0 0 0-16-16m-40 80h40v48h-40Zm40-16h-40v-8a16 16 0 0 0-16-16V40h56ZM72 40h56v24H72ZM40 80h104v96H40Zm32 112h56v24H72Zm72 24v-24a16 16 0 0 0 16-16v-8h40v48Zm-78.15-69.12L81.59 128l-15.74-18.88a8 8 0 0 1 12.3-10.24L92 115.5l13.85-16.62a8 8 0 1 1 12.3 10.24L102.41 128l15.74 18.88a8 8 0 0 1-12.3 10.24L92 140.5l-13.85 16.62a8 8 0 0 1-12.3-10.24" />
                  </svg>
                </Avatar>
                <div>
                  <Typography fontSize={"small"} color={"GrayText"}>{new Intl.DateTimeFormat('en-ZA', {
                    dateStyle: 'full',
                    timeStyle: 'long',
                  }).format(new Date(item?.insertDateTime))}</Typography>
                  <Typography fontSize={"x-small"} color={"GrayText"}>{item?.userEmail}</Typography>
                  <Typography fontSize={"x-small"} color={"GrayText"}>{item?.sheetName}</Typography>
                  <Typography fontSize={"x-small"} color={"GrayText"}>{item?.dealType}</Typography>
                </div>

              </Stack>
              <Link href={item?.storageLink}>
                {item?.fileName}
              </Link>
            </Stack>
          </Card>
        ))}
      </Stack>
      </ScrollEffect>
    </Modal>
  )
}
